export default __webpack_public_path__ + "static/media/tab_logo_green_footer.d3315995.png";